import { ExternalLinkIcon } from '../assets';
import { contactCards, socialLinks } from '../constants';
import { SectionWrapper } from '../hoc';
import { styles } from '../styles';

const ContactCard = ({ title, data, icon, href }) => (
  <div
    className="flex flex-col bg-card-color border border-[#ffffff3f] p-6 relative rounded-lg shadow-[0_4px_30px_rgba(0,0,0,0.1)] min-w-[300px] flex-1"
    // style={{
    //   minWidth: 'fit-content',
    // }}
  >
    <div className="font-bold text-xl">{title}</div>

    <div className="mt-2">
      {href && (
        <a
          href={href}
          target="_blank"
          className="flex items-center gap-2 flex-wrap"
        >
          <p className="text-sm">{data}</p>
          <div className="w-5 h-5 inline-block object-contain">
            <ExternalLinkIcon className="stroke-txt-primary fill-card-color w-full h-full" />
          </div>
        </a>
      )}

      {!href && <p className="text-sm">{data}</p>}
    </div>
  </div>
);

const SocialLink = ({ href, Icon }) => (
  <a className="" aria-label="Follow on X" href={href} target="_blank">
    <div className="h-10 w-10">
      <Icon className="fill-txt-primary h-full w-full" />
    </div>
  </a>
);

const Contact = () => {
  return (
    <>
      <div className={`${styles.sectionHeadText}`}>Contact</div>
      <div className="mt-5 grid gap-4 grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3">
        {/* <div className="mt-7 flex flex-wrap gap-3 "> */}
        {contactCards.map((item, idx) => (
          <ContactCard key={idx} {...item} />
        ))}
      </div>
      <div className="mt-10 flex gap-6 items-center justify-center ">
        {socialLinks.map((item, idx) => (
          <SocialLink key={idx} {...item} />
        ))}
      </div>
    </>
  );
};

export default SectionWrapper(Contact, 'contact');
